<template>
  <div class="header col-12 hide-phone">
<!--    <div class="header col-12 " v-if="showMenu">-->
<!--      asd-->
<!--    </div>-->
    <div class="row no-children-v-gutters justify-content-space-between">
      <div class="page-title col-3"><h4>{{ title }}</h4></div>
      <div class="right col-8 align-self-end" v-if="currentUser">
        <a
            href="https://app.weeek.net/s/kontragentam-document-NTE2NjczfDlmM2IxMjgzLWZkMWEtNGFjYy1iMjYxLTY1YTI0ZTcxMzcwNw=="
            target="_blank"
            rel="noopener noreferrer"
            title="Открыть инструкцию"
            class="help_link"
        >
        <span class="help_icon">
          <img src="@/assets/help.png" alt="Help Icon" />
        </span>
<!--          <span class="right-space-16">Информация</span>-->
        </a>
        <span> |   </span>
        <span class="avatar right-space-16">{{ currentUser.username.substr(0, 2).toUpperCase() || '' }}</span>
        <span class="right-space-16">{{ currentUser.username }} ({{ currentUser.groups[0] }})</span>

        <span class="logout"> | <a @click="logout">Выйти</a></span>
        <!--           <span v-if="isLoggedIn"> | <a @click="logout">Logout</a></span>-->
      </div>
    </div>
  </div>
  <div class="header col-12 hide show-phone no-v-gutters mobile-header" >
    <div class="row no-children-v-gutters align-items-center mobile-header-row">
      <div class="col-3 mobile-menu-icon" >
        <span class="icon-list mobile-burger-icon" @click="toggle()"></span>
      </div>
      <div class="col-6 mobile-logo-wrapper">
        <router-link to="/"><img class="logo mobile-logo" src="@/assets/logo.png" alt=""></router-link>
      </div>
      <div class="col-3 mobile-avatar-wrapper" v-if="currentUser">
        <span class="avatar mobile-avatar" @click="showMobileMenu = !showMobileMenu">{{ currentUser.username.substr(0, 2).toUpperCase() || 'АП' }}</span>
        <div class="mobile-dropdown-menu" v-if="showMobileMenu">
          <div class="mobile-dropdown-item mobile-user-info">
            {{ currentUser.username }}
          </div>
          <div class="mobile-dropdown-item" @click="logout">
            Выйти
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Дашборд",
      showMobileMenu: false,
    }
  },
  computed : {
    currentUser() {
      return this.$store.state.auth.user;
    },
    // showMenu() {
    //   return this.$store.state.showMenu;
    // }
  },
  methods: {
    logout: function () {
      this.showMobileMenu = false;
      this.$store.dispatch('auth/logout')
          .then(() => {
            this.$router.push('/login')
          })
    },
    toggle() {
      this.$store.dispatch('toggleShowMenu');
    }

  },
};
</script>

<style scoped>
.mobile-avatar-wrapper {
  position: relative;
}

.mobile-avatar {
  cursor: pointer;
}

.mobile-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  overflow: hidden;
}

.mobile-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-dropdown-item:last-child {
  border-bottom: none;
}

.mobile-dropdown-item:hover {
  background-color: #f5f5f5;
}

.mobile-user-info {
  font-weight: 600;
  color: #333;
  cursor: default;
}

.mobile-user-info:hover {
  background-color: white;
}
</style>
